export const GET_CURRENT_STEP = 'GET_CURRENT_STEP'
export const GET_OPTION_STATE = 'GET_OPTION_STATE'
